// ==============================|| OVERRIDES - DIVIDER ||============================== //

export default function Divider(theme) {
  return {
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.grey[200],
          marginTop: theme.spacing(0.5),
          marginBottom: theme.spacing(0.5)
        }
      }
    }
  };
}
